import { Stack, Typography, useTheme } from "@mui/material";
import { CheckCircle2, Circle } from "lucide-react";
import type { FC } from "react";
import type { GetTaskWorkflowStepResponse } from "web_myplann/Infrastructure/Api/Api";
import { IconBox } from "web_myplann/Shared/Components/IconBox";
import {
	dateFormatter,
	SHORT_DATE_FORMAT,
} from "web_myplann/Shared/Utils/dateFormatters";

type Props = {
	data: GetTaskWorkflowStepResponse;
};

export const TaskSubtaskRow: FC<Props> = ({ data }) => {
	const theme = useTheme();
	const { isCompleted, name, completedDate, dueDate } = data;

	const date = isCompleted ? completedDate : dueDate;
	const formattedDate = dateFormatter(date, SHORT_DATE_FORMAT);

	return (
		<Stack
			direction="row"
			alignItems="flex-start"
			gap={1.2}
			px={1.6}
			py={1.2}
			borderBottom={1}
			borderColor="surface.border"
		>
			<IconBox
				size={32}
				bg={isCompleted ? theme.palette.green[50] : theme.palette.grey[100]}
			>
				{isCompleted ? (
					<CheckCircle2
						size={theme.iconSize.sm}
						color={theme.palette.green[500]}
					/>
				) : (
					<Circle size={theme.iconSize.sm} color={theme.palette.grey[400]} />
				)}
			</IconBox>
			<Stack flex={1} minWidth={0}>
				<Typography
					variant="body1"
					color={isCompleted ? "text.secondary" : "text.primary"}
				>
					{name}
				</Typography>
				{formattedDate && (
					<Typography variant="hint" mt={0.4}>
						{formattedDate}
					</Typography>
				)}
			</Stack>
		</Stack>
	);
};
